module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12xeiP3/tc-custom/9781453204597.jpg?1733086023976",
      "alt": "This image is the cover for the book Essays in Humanism"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Essays in Humanism\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The great thinker reflects on such topics as nuclear weapons, world poverty, and international affairs in this "), _c('i', [_vm._v("Wall Street Journal")]), _vm._v(" bestseller.")]), _c('br'), _c('br'), _vm._v(" Nuclear proliferation, Zionism, and the global economy are just a few of the insightful and surprisingly prescient topics scientist Albert Einstein discusses in this volume of collected essays from between 1931 and 1950. Written with a clear voice and a thoughtful perspective on the effects of science, economics, and politics in daily life, Einstein’s essays provide an intriguing view inside the mind of a genius addressing the philosophical challenges presented during the turbulence of the Great Depression, the Second World War, and the dawn of the Cold War."), _c('br'), _c('br'), _c('i', [_vm._v("This authorized ebook features rare photos and never-before-seen documents from the Albert Einstein Archives at the Hebrew University of Jerusalem.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Albert Einstein\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p'), _vm._v("Albert Einstein (1879–1955) was born in Germany and became an American citizen in 1940. A world-famous theoretical physicist, he was awarded the 1921 Nobel Prize for Physics and is renowned for his Theory of Relativity. In addition to his scientific work, Einstein was an influential humanist who spoke widely about politics, ethics, and social causes. After leaving Europe, Einstein taught at Princeton University. His theories were instrumental in shaping the atomic age."), _c('p'), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0